import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "../../common";

const ROLE_ITEMS_SHOW = "middleware/roleItems";
const PERMISSIONS_PATH_SHOW = "middleware/permissionsPath";
const PERMISSIONS_NAVIGATION_OID_SHOW = "middleware/permissionsNavigationOid";

export const showRoleItems = createAsyncThunk(
  ROLE_ITEMS_SHOW,
  async (payload, thunkAPI) => {
    try {
      const roleItems = await axios.get(`/GetPermissionInfo(${payload})`);
      return roleItems;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const IsPermisionOidRequired = createAsyncThunk(
  PERMISSIONS_NAVIGATION_OID_SHOW,
  async (thunkAPI) => {
    try {
      const RoleDetailArray =
        localStorage.getItem("RoleDetail") &&
        JSON.parse(localStorage.getItem("RoleDetail"));

      const navigationOid =
        localStorage.getItem("NavigationOid") &&
        localStorage.getItem("NavigationOid");

      const RoleDetail = RoleDetailArray.find(
        (item) => item.Navigation.Oid === navigationOid
      );
      return RoleDetail;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const IsPermisionPathRequired = createAsyncThunk(
  PERMISSIONS_PATH_SHOW,
  async (payload, thunkAPI) => {
    try {
      const RoleDetailArray = JSON.parse(localStorage.getItem("RoleDetail"));

      const NAVIGATION_PATH = payload;
      const RoleDetail = RoleDetailArray.find(
        (item) => item.Navigation.path === NAVIGATION_PATH
      );
      return RoleDetail;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
